import * as types from "./canvastypes";
const w = document.documentElement.clientWidth;
const h = document.documentElement.clientHeight;

export const canvas = {
  namespaced: true,

  state: {
    sendDrawingRes: {width: 210, height: 210},
    pixelRatio: 2,
    /**
     * 保存できるか。なんも描いてないと保存できない。
     */
    savable: false,
    defaultScale: 2,
    textInputScale: 1.3,
    scale: .5,
    offset: { x: 0, y: 0 },
    history: {
      last: null,
      max: 10
    },
    stage: {
      width: w, //375
      height: h //700
    },
    myDrawingURL: null,
    drawn: false
  },
  getters: {
    stage(state) {
      return state.stage;
    }
  },
  mutations: {
    setHistoryLast(state, last) {
      state.history.last = last;
    },
    setOffset(state, offset) {
      state.offset.x = offset.x;
      state.offset.y = offset.y;
    },
    setMyDrawingURL(state, url) {
      state.myDrawingURL = url;
    },
    setStageSize(state, size) {
      state.stage.width = size.width;
      state.stage.height = size.height;
    },
    setScale(state, scale) {
      state.scale = scale;
    },
    setSavable(state, flag) {
      state.savable = flag;
    },
    setSendRes(state, res) {
      state.sendDrawingRes.width = res.width;
      state.sendDrawingRes.height = res.height;
    },
    setDrawn(state, flag) {
      state.drawn = flag;
    },
    setPixelRatio(state, ratio) {
      state.pixelRatio = ratio;
    }
  },
  actions: {
    [types.SET_HISTORY_LAST]({ commit }, last) {
      commit("setHistoryLast", last);
    },
    [types.SET_OFFSET]({ commit }, offset) {
      commit("setOffset", offset);
    },
    [types.SET_MY_DRAWING_URL]({ commit }, url) {
      commit("setMyDrawingURL", url);
    },
    [types.SET_STAGE_SIZE]({ commit }, size) {
      commit("setStageSize", size);
    },
    [types.SET_SCALE]({ commit }, scale) {
      commit("setScale", scale);
    },
    [types.SET_SAVABLE]({ commit }, flag) {
      commit("setSavable", flag);
    },
    [types.SET_SEND_RES]({ commit }, res) {
      commit("setSendRes", res);
    },
    [types.SET_PIXEL_RATIO]({ commit }, ratio) {
      commit("setPixelRatio", ratio);
    },
    [types.SET_DRAWN]({ commit }, flag) {
      commit("setDrawn", flag);
    }
  }
};
